// extracted by mini-css-extract-plugin
export default {"spinner":"LazyRoutesContainer_spinner_ce006"};